var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitPagePreview = void 0;
const react_1 = require("react");
const admin_core_1 = require("@wheelroom/admin-core");
const query_string_1 = __importDefault(require("query-string"));
const router_1 = require("@reach/router");
const page_preview_register_1 = require("./page-preview-register");
const page_preview_reducer_1 = require("./page-preview-reducer");
const initial_state_1 = require("./initial-state");
const action_creator_1 = require("./action-creator");
exports.useInitPagePreview = (pageProps) => {
    const location = router_1.useLocation();
    const { adminCoreDispatch } = react_1.useContext(admin_core_1.AdminCoreContext);
    const [pagePreviewState, pagePreviewDispatch] = react_1.useReducer(page_preview_reducer_1.pagePreviewReducer, initial_state_1.initialState);
    const actions = action_creator_1.actionCreator(pagePreviewState, pagePreviewDispatch);
    react_1.useEffect(() => {
        adminCoreDispatch(page_preview_register_1.pagePreviewRegister);
    }, []);
    react_1.useEffect(() => {
        adminCoreDispatch({
            type: 'SET_PAGE_PROPS',
            pageProps,
        });
    }, [pageProps]);
    react_1.useEffect(() => {
        const queryParams = query_string_1.default.parse(location.search);
        pagePreviewState.inPreviewMode = 'preview' in queryParams;
        adminCoreDispatch({
            type: 'SET_ADMIN_MODULE_STORE',
            moduleId: page_preview_register_1.pagePreviewRegister.moduleId,
            store: {
                actions,
                state: pagePreviewState,
                dispatch: pagePreviewDispatch,
            },
        });
        adminCoreDispatch({
            type: 'SET_LAST_MODULE_ID',
            moduleId: page_preview_register_1.pagePreviewRegister.moduleId,
        });
    }, [pagePreviewState]);
};
//# sourceMappingURL=use-init-page-preview.js.map